import PropTypes from 'prop-types'
import React, { createContext, useState, useCallback, useMemo } from 'react';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  const showToast = useCallback((message) => {
    setMessage(message);
    setShow(true);
  }, []);

  const contextValue = useMemo(() => ({ show, message, showToast, setShow }), [show, message, showToast, setShow]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};